import { SwiperEvents, SwiperOptions } from 'swiper/types';
import { MarqueeOptions } from './plugin/marquee';

export namespace Carousel {
    export interface Options extends SwiperOptions {
        loopedSlides?: number | null;
        marquee?: boolean | MarqueeOptions;
    }

    export interface ChangeEvent {
        index: number;
        id: string;
    }

    export type EventsParams<T = SwiperEvents> = {
        [P in keyof T]: T[P] extends (...args: any[]) => any ? Parameters<T[P]> : never;
    };

    export enum ArrowDirection {
        prev = 'prev',
        next = 'next'
    }

    /* underscore in name -> watch for changes */
    export const PARAMS_KEYS = [
        '_allowSlideNext',
        '_allowSlidePrev',
        '_allowTouchMove',
        '_autoHeight',
        'breakpoints',
        'breakpointsBase',
        '_centerInsufficientSlides',
        '_centeredSlides',
        '_centeredSlidesBounds',
        'containerModifierClass',
        'createElements',
        'cssMode',
        '_direction',
        '_edgeSwipeDetection',
        '_edgeSwipeThreshold',
        '_effect',
        'enabled',
        'eventsPrefix',
        'focusableElements',
        '_followFinger',
        '_grabCursor',
        '_height',
        'initialSlide',
        'injectStyles',
        'injectStylesUrls',
        'lazyPreloadPrevNext',
        'lazyPreloaderClass',
        '_longSwipes',
        'longSwipesMs',
        'longSwipesRatio',
        '_loop',
        '_loopAddBlankSlides',
        '_loopAdditionalSlides',
        '_loopPreventsSliding',
        'maxBackfaceHiddenSlides',
        'nested',
        '_noSwiping',
        'noSwipingClass',
        'noSwipingSelector',
        'normalizeSlideIndex',
        'observeParents',
        'observeSlideChildren',
        'observer',
        'on',
        'oneWayMovement',
        'passiveListeners',
        'preventClicks',
        'preventClicksPropagation',
        'preventInteractionOnTransition',
        '_resistance',
        '_resistanceRatio',
        'resizeObserver',
        '_rewind',
        'roundLengths',
        'runCallbacksOnInit',
        'setWrapperSize',
        '_shortSwipes',
        'simulateTouch',
        'slideActiveClass',
        'slideBlankClass',
        'slideClass',
        'slideFullyVisibleClass',
        'slideNextClass',
        'slidePrevClass',
        '_slideToClickedSlide',
        'slideVisibleClass',
        '_slidesOffsetAfter',
        '_slidesOffsetBefore',
        '_slidesPerGroup',
        '_slidesPerGroupAuto',
        '_slidesPerGroupSkip',
        '_slidesPerView',
        '_spaceBetween',
        '_speed',
        '_swipeHandler',
        'swiperElementNodeName',
        '_threshold',
        'touchAngle',
        'touchEventsTarget',
        'touchMoveStopPropagation',
        'touchRatio',
        'touchReleaseOnEdges',
        'touchStartForcePreventDefault',
        'touchStartPreventDefault',
        'uniqueNavElements',
        'updateOnWindowResize',
        'url',
        'userAgent',
        '_watchOverflow',
        '_watchSlidesProgress',
        '_width',
        'wrapperClass'
    ];

    // Events that are called before the swiper is fully initialized
    export const EVENTS_BEFORE_INIT = [
        'beforeInit',
        'slidesLengthChange',
        'unlock',
        'snapGridLengthChange',
        'slidesGridLengthChange',
        'slidesUpdated',
        'progress',
        'snapIndexChange',
        'init',
        'afterInit'
    ];
}
